import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@bbj/components";

@Component({
  selector: "app-signout",
  templateUrl: "./signout.component.html",
  styleUrls: ["./signout.component.scss"],
  standalone: false
})
export default class SignoutComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  private activeRoute = inject(ActivatedRoute);


  ngOnInit(): void {
    if (this.activeRoute.routeConfig.path === "logout") {
      this.authService.logout();
    }
  }

  login(): void {
    this.router.navigate(["/"]);
  }
}
